import { render, staticRenderFns } from "./LayoutReport.vue?vue&type=template&id=236300d6&"
import script from "./LayoutReport.vue?vue&type=script&lang=js&"
export * from "./LayoutReport.vue?vue&type=script&lang=js&"
import style0 from "./LayoutReport.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports